import { create } from 'zustand';
import { TONE, TOAST_DURATION_MS, TOAST_MAX_VISIBLE } from '../lib/rcu/catalog/feedback';
import type { Tone } from '../lib/rcu/catalog/feedback';

export interface Toast {
  readonly id: string;
  readonly tone: Tone;
  readonly message: string;
}

interface ToastStore {
  readonly toasts: readonly Toast[];
  push: (message: string, tone: Tone) => void;
  dismiss: (id: string) => void;
  success: (message: string) => void;
  error: (message: string) => void;
  info: (message: string) => void;
}

/** Monotonic ids: a toast only needs to be unique on screen. */
let sequence = 0;

const nextId = (): string => {
  sequence += 1;
  return String(sequence);
};

export const useToastStore = create<ToastStore>((set, get) => ({
  toasts: [],

  push: (message, tone) => {
    const toast: Toast = { id: nextId(), tone, message };
    set(({ toasts }) => ({ toasts: [...toasts, toast].slice(-TOAST_MAX_VISIBLE) }));
    setTimeout(() => {
      get().dismiss(toast.id);
    }, TOAST_DURATION_MS);
  },

  dismiss: (id) => set(({ toasts }) => ({ toasts: toasts.filter((toast) => toast.id !== id) })),

  success: (message) => get().push(message, TONE.SUCCESS),
  error: (message) => get().push(message, TONE.ERROR),
  info: (message) => get().push(message, TONE.INFO),
}));

export default useToastStore;
